import { get } from 'svelte/store'

import { getLanguage } from '$lib/context.js'

/** @typedef {{ amount: number, currency: string }} Money */

/** @type {Intl.NumberFormatOptions & { trailingZeroDisplay: string }} */
export const WITHOUT_DECIMALS = {
  trailingZeroDisplay: 'stripIfInteger'
}

/**
 * @param {Money} money
 * @param {Intl.NumberFormatOptions} [override]
 * @returns {string}
 */
export function money(money, override) {
  const { amount, currency } = money

  // Render local currency in local format
  const locale = currency === 'SEK' ? 'sv' : get(getLanguage())

  /** @type {Intl.NumberFormatOptions} */
  const options = {
    currencyDisplay: 'narrowSymbol',
    style: 'currency',
    currency
  }

  // Allow for custom overrides
  if (override) Object.assign(options, override)
  if (currency === 'SEK') Object.assign(options, WITHOUT_DECIMALS)
  if (currency === 'DKK') Object.assign(options, WITHOUT_DECIMALS)

  return (amount / 100).toLocaleString(locale, options)
}
